/**
 * Códigos de erro das configurações da empresa (`CompaniesSettings`).
 */
export const COMPANY_SETTINGS_ERRORS = {
  /** 400 — `column` não é uma configuração da empresa (PUT /companySettings, GET /companySettingOne). */
  INVALID_COLUMN: "ERR_COMPANY_SETTINGS_INVALID_COLUMN"
} as const;

export type CompanySettingsErrorCode = (typeof COMPANY_SETTINGS_ERRORS)[keyof typeof COMPANY_SETTINGS_ERRORS];
